/* eslint-disable react/jsx-props-no-spreading */
import React from "react";
import PropTypes from "prop-types";
import ReCaptcha from "react-google-recaptcha";
import { Controller } from "react-hook-form";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";

function ReCaptchaComp(props) {
  const { name, control, required = true, theme, error, captchaRef } = props;

  return (
    <Grid
      sx={{
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Controller
        name={name}
        control={control}
        render={({ field: { onChange, ref, ...field } }) => (
          <ReCaptcha
            {...field}
            /* keep the hook form ref while exposing the widget to the parent
               so it can be reset between submits */
            ref={(instance) => {
              ref(instance);
              if (captchaRef) captchaRef.current = instance;
            }}
            onChange={(captchaToken) => {
              onChange(captchaToken);
            }}
            sitekey={process.env.REACT_APP_CAPTCHA_KEY}
            theme={theme}
          />
        )}
        rules={{ required }}
      />
      {error && (
        <Typography variant="body2" color="error" sx={{ mb: "1em" }}>
          {`Please check the "I am not a robot" checkbox`}
        </Typography>
      )}
    </Grid>
  );
}
ReCaptchaComp.propTypes = {
  name: PropTypes.string.isRequired,
  theme: PropTypes.string.isRequired,
  control: PropTypes.oneOfType([PropTypes.object]).isRequired,
  required: PropTypes.bool,
  error: PropTypes.oneOfType([PropTypes.bool, PropTypes.any]).isRequired,
  captchaRef: PropTypes.oneOfType([PropTypes.object]),
};
ReCaptchaComp.defaultProps = {
  required: true,
  captchaRef: undefined,
};

export default ReCaptchaComp;
